import script from "./PillButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PillButton.vue?vue&type=script&setup=true&lang=js"

import "./PillButton.vue?vue&type=style&index=0&id=0d047f2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d047f2a"]])

export default __exports__